import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Form, Input, Button, Divider, Modal, Spin } from 'antd';
import { ReactComponent as ListPoint } from '../../lib/img/list-point.svg';
import { resetPasswordRoute } from '../../lib/routes/routes';
import './PasswordRecovery.less';
import PasswordHint from '../PasswordHint/PasswordHint';
import usePasswordValidate from '../../lib/utils/usePasswordValidate';

const PasswordRecovery = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [recoveryForm] = Form.useForm();
  const [loadingData, setLoadingData] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const {
    isRepeatedPasswordValidator,
    isPasswordValidator,
    handlePaste,
    isPasswordSameValidator,
    handleValuePassword,
  } = usePasswordValidate();

  const handleSubmit = ({ newPassword }) => {
    setLoadingData(true);
    const token = searchParams.get('token') || '';
    const bodyRequest = { password: newPassword, token: token };
    axios
      .post(resetPasswordRoute(), bodyRequest)
      .then(() => {
        Modal.success({
          content: (
            <>
              <div>Пароль успешно сохранён</div>
              <div>Используйте новый пароль для входа</div>
            </>
          ),
          className: 'password-forgotten-info-modal',
          width: '530px',
          bodyStyle: {
            backgroundColor: '#F4F4F4',
            paddingTop: '20px',
            marginTop: '111px',
          },
          okButtonProps: {
            style: {
              marginRight: '158px',
            },
          },
          okText: 'Войти',
          onOk: () => {
            navigate('/login');
          },
        });
      })
      .catch((error) => {
        Modal.error({
          title: 'Произошла ошибка',
          content: error.response.data.message || 'Пожалуйста, попробуйте позднее',
          className: 'password-recovery-info-modal',
          width: '530px',
          bodyStyle: {
            backgroundColor: '#F4F4F4',
            paddingTop: '20px',
            marginTop: '111px',
          },
          okButtonProps: {
            style: {
              // marginRight: '158px',
            },
          },
        });
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  // Для нового пароля проверки (чтобы показывать одно сообщение об ошибке одновременно)
  const combinedPasswordValidator = async () => {
    try {
      await isPasswordSameValidator({ form: recoveryForm });
    } catch {
      throw new Error(' ');
    }

    try {
      await isPasswordValidator({ form: recoveryForm });
    } catch {
      throw new Error('Пароль слишком простой');
    }

    return Promise.resolve();
  };

  return (
    <div className="password-recovery">
      <div className="password-recovery-container">
        <div className="password-recovery-innerContainer">
          <div className="logo" />
          <h1 className="password-recovery-title">Смена пароля</h1>
          <Divider />
          <Spin spinning={loadingData}>
            <Form
              form={recoveryForm}
              name="basic"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleSubmit}
              onValuesChange={(field, fields) => {
                combinedPasswordValidator()
                  .then(() => setIsPasswordValid(true))
                  .catch(() => setIsPasswordValid(false));
              }}
            >
              <div className="font-roboto text-left">Для восстановления доступа к аккаунту, создайте новый пароль.</div>
              <div className="font-roboto text-left mt12">
                Пароль должен быть не менее 8 символов и содержать хотя бы по одному символу из четырёх следующих групп:
              </div>
              <PasswordHint mtListItem={8} />
              <Form.Item
                dependencies={['repeatedPassword']}
                label="Новый пароль"
                name="newPassword"
                validateStatus={isPasswordValid ? 'success' : undefined}
                help={isPasswordValid ? 'Надёжный пароль' : undefined}
                getValueFromEvent={handleValuePassword}
                rules={[
                  { required: true, message: '' },
                  {
                    validator: combinedPasswordValidator,
                  },
                ]}
                className={`password-recovery-password mt10 ${isPasswordValid ? 'validate-success-message' : ''}`}
              >
                <Input.Password placeholder="Новый пароль" allowClear maxLength={32} onPaste={handlePaste} />
              </Form.Item>
              <Form.Item
                dependencies={['newPassword']}
                label="Подтверждение нового пароля"
                name="repeatedPassword"
                getValueFromEvent={handleValuePassword}
                rules={[
                  { required: true, message: '' },
                  {
                    validator: () => isRepeatedPasswordValidator({ form: recoveryForm }),
                    message: 'Пароль не совпадает',
                  },
                ]}
                className="password-recovery-password mt4"
              >
                <Input.Password placeholder="Подтверждение пароля" allowClear maxLength={32} onPaste={handlePaste} />
              </Form.Item>
              <div className="mt20">
                <Form.Item shouldUpdate>
                  {({ getFieldsValue }) => {
                    const { newPassword, repeatedPassword } = getFieldsValue();
                    return (
                      <Button type="primary" htmlType="submit" className="ml20 password-recovery-submitBtn">
                        Сохранить
                      </Button>
                    );
                  }}
                </Form.Item>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;
